/**
 * @file 행사장 API
 * 행사장 지역 목록, 전체 행사장 목록 조회, 조건 검색, 파일 업로드 등을 처리합니다.
 */

import { api } from "../../../../util/api";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const eventVenueApi = {
    /** 행사장 지역 목록 조회 */
    getRegions: ()         => api.get(`${API_BASE}/event-venue/region-list`),

    /** 전체 행사장 목록 조회 */
    getList:    ()         => api.get(`${API_BASE}/event-venue/list`),

    /** 행사장 조건 검색
     * @param {object} params - 검색 조건 (지역, 수용인원, 유형 등)
     */
    search:     (params)   => api.post(`${API_BASE}/event-venue/search`, params),

    /** 행사장 파일 업로드 (multipart/form-data)
     * @param {FormData} formData - 업로드할 파일이 담긴 FormData
     */
    upload:     (formData) => api.upload(`${API_BASE}/event-venue/upload`, formData),
};
